import React, { Component } from 'react'
import { translate } from "react-i18next"

import './Navigation.css'

class DaySelectionNav extends Component {
  render() {
    const { navPrev, navNext=true, t, calendarView="WEEK" } = this.props

    return (
      <div className="day-selection-nav">
        {
          navPrev && (
            <div className="month-nav prev" onClick={() => this.props.onNav('prev')}>
              <i className="fa fa-angle-left" /> <span>{ t(`previous-${calendarView.toLowerCase()}`) }</span>
            </div>
          )
        }
        {
          navNext && (
            <div className="month-nav next" onClick={() => this.props.onNav('next')}>
              <i className="fa fa-angle-right" /> <span>{ t(`next-${calendarView.toLowerCase()}`) }</span>
            </div>
          )
        }
      </div>
    );
  }
}

export default translate("translations")(DaySelectionNav)
